export const convertUTCDataToUTCDate = (dayOfWeekUTC: number, hourOfWeekUTC: number, minutesUTC: number) => {
  const date = new Date()
  const currentDay = date.getDay()
  const distance = dayOfWeekUTC - currentDay
  date.setDate(date.getDate() + distance)
  date.setUTCHours(hourOfWeekUTC)
  date.setUTCMinutes(minutesUTC)
  date.setUTCSeconds(0)
  date.setUTCMilliseconds(0)
  return date
}

const getDayWithLocalTime = (dayUTC: number, dateUTC: Date) =>
  dateUTC.getUTCDay() !== dateUTC.getDay() ? (dayUTC - 1 < 0 ? 6 : dayUTC - 1) : dayUTC

export type Sched = {
  startDayOfWeekUTC: number | undefined
  startHoursUTC: number | undefined
  startMinutesUTC: number | undefined
}

export const getSchedulesForDay = (schedule: Sched, day: ReturnType<Date['getUTCDay']>) => {
  const { startDayOfWeekUTC, startHoursUTC, startMinutesUTC } = schedule
  if (
    (startDayOfWeekUTC || startDayOfWeekUTC === 0) &&
    (startHoursUTC || startHoursUTC === 0) &&
    (startMinutesUTC || startMinutesUTC === 0)
  ) {
    const scheduleDate = convertUTCDataToUTCDate(startDayOfWeekUTC, startHoursUTC, startMinutesUTC)
    const localDay = getDayWithLocalTime(startDayOfWeekUTC, scheduleDate)
    return localDay === day
  }
  return false
}

export const utcDateToLocalDate = (dateIsoString: string) => {
  const originalDate = new Date(dateIsoString)

  // convert to msec since Jan 1 1970
  const originalTime = originalDate.getTime()

  // obtain local UTC offset and convert to msec
  const originalOffset = originalDate.getTimezoneOffset() * 60 * 1000

  // obtain UTC time in msec
  const utcTime = originalTime - originalOffset

  // obtain and add destination's UTC time offset
  const localOffset = new Date().getTimezoneOffset()
  const localTime = utcTime + 60 * 1000 * localOffset

  // convert msec value to date string
  return new Date(localTime)
}
